import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";
import VatNumberDetails from "components/VatNumber/VatNumberDetails";
import React from "react";
import { getCountryFormDefinition } from "shared/utils/cmsUtils";

interface Props {
  promoter: server.dto.Company
  displayTooltip: boolean
}

const renderPreview = (props: Props) => (
  <CompanySidePanel type="promoter"
    companyId={props.promoter.companyId}
    trigger={<a>{props.promoter.admName}</a>}
    fallbackIfNoPermission={<strong>{props.promoter.admName}</strong>}
  />
);

const ReadonlyPromoter = (props: Props) => {
  const addressLines = props.promoter.admAddress?.formatted ?? [];
  const promoterCountryFormDefinition = getCountryFormDefinition(props.promoter.admAddress?.country, serverReference);

  return <div className="flex gap" style={{ flex: 1 }}>
    <div className="flex-column gap">
      <div>
        <div>
          {props.displayTooltip && renderPreview(props)}
          {!props.displayTooltip && <strong>{props.promoter.admName}</strong>}
        </div>
        <div className="margin-bottom-small">
          {addressLines.map((l, idx) => <div key={idx}>{l}</div>)}
        </div>
      </div>
      {promoterCountryFormDefinition.euVatNumber.displayInUI && props.promoter.euVatNumber?.number != null && <div>
        <div className="text-sublabel">{promoterCountryFormDefinition.euVatNumber.label}</div>
        <VatNumberDetails companyId={props.promoter.companyId} euVatNumber={props.promoter.euVatNumber} displayDot hideRefresh />
      </div>}
      {promoterCountryFormDefinition.fiscalNumber1.displayInUI && props.promoter.fiscalNumber1 != null && <div>
        <div className="text-sublabel">{promoterCountryFormDefinition.fiscalNumber1.label}</div>
        <div>{props.promoter.fiscalNumber1}</div>
      </div>}
      {promoterCountryFormDefinition.fiscalNumber2.displayInUI && props.promoter.fiscalNumber2 != null && <div>
        <div className="text-sublabel">{promoterCountryFormDefinition.fiscalNumber2.label}</div>
        <div>{props.promoter.fiscalNumber2}</div>
      </div>}
      {promoterCountryFormDefinition.businessRegistrationNumber.displayInUI && props.promoter.businessRegistrationNumber != null && <div>
        <div className="text-sublabel">{promoterCountryFormDefinition.businessRegistrationNumber.label}</div>
        <div>{props.promoter.businessRegistrationNumber}</div>
      </div>}
    </div>
  </div>;
};

export default ReadonlyPromoter;
